import * as ReturnCodesConstants from '../../../../../constants/ReturnCodesConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import { mapActions, mapState } from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'

export default {
  data () {
    return {
      dialogVisibleProgramPrint: false,
      flag: false,
      submitFalse: false,
      searchInput: '',
      id: '',
      centerHeight: document.documentElement.clientHeight - 130 + 'px',
      model: 1
    }
  },
  computed: {
    ...mapState('productDetailsModule', ['productDetailsInfo']),
    productDetails () {
      return this.productDetailsInfo
    },
    productDetailsCodeToFileIds () {
      if (!this.productDetailsInfo || !this.productDetailsInfo.codeToFileIds) {
        return {}
      }
      return this.productDetailsInfo.codeToFileIds
    },
    productDetailsFileIds () {
      return code => {
        if (!this.productDetailsCodeToFileIds[code] ||
          !this.productDetailsCodeToFileIds[code].length) {
          return []
        }

        return this.productDetailsInfo.codeToFileIds[code]
      }
    },
    productImages () {
      return this.productDetailsFileIds('details')
    },
    productCarousels () {
      return this.productDetailsFileIds('carousel')
    }
  },
  methods: {
    ...mapActions('productDetailsModule', ['getProductDetails', 'purchaseProduct']),
    goBack (item) {
      this.$router.push({
        path: RoutePathConstants.POINTS_MAIL_HOME_PAGE,
        query: {
        }
      })
    },
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    },
    getProductDetailsInfo () {
      this.getProductDetails({ 'id': this.id })
    },
    async purchase () {
      // this.flag = true
      // this.dialogVisibleProgramPrint = true
      this.$router.push({
        path: RoutePathConstants.PRODUCT_PAY,
        query: {
          id: this.id
        }
      })
    },
    async submit () {
      this.submitFalse = true
      this.dialogVisibleProgramPrint = false
      let res = await this.purchaseProduct({ 'commodityId': this.id })
      if (res && res.code == ReturnCodesConstants.SUCCESS_CODE) {
        this.$message.success('兑换成功!')
        let _this = this
        setTimeout(_this.goBack(), 3000)
      } else if (res.data.code == ReturnCodesConstants.FAIL_EXCHANGE) {
        this.$message.warning('积分不足，兑换失败!')
      }
    }
  },
  mounted () {
    document.title = '商品详情'
    this.id = this.$route.query.id
    this.getProductDetailsInfo()
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/product-details/views/product-details.js